import React from 'react';
import { FixedBottomButton } from '../SubjectForm.styles';
import { useTranslation } from 'react-i18next';

interface ActionFooterProps {
  canSubmitReport: boolean;
  allRowsConfirmed: boolean;
  reportConsent: boolean;
  saveUserBiomarkersToStorage: () => void;
  fieldsVisible: boolean;
  isFileProcessed: boolean;
  onGenerateAndUploadPdf: () => void;
  collectAllBiomarkersData?: () => any[];
}

const ActionFooter: React.FC<ActionFooterProps> = ({
  canSubmitReport,
  allRowsConfirmed,
  reportConsent,
  saveUserBiomarkersToStorage,
  fieldsVisible,
  isFileProcessed,
  onGenerateAndUploadPdf,
  collectAllBiomarkersData
}) => {
  const { t } = useTranslation();

  return (
    <FixedBottomButton>
      <button
        className={'btn'}
        style={{
          opacity: canSubmitReport ? 1 : 0.5,
          cursor: canSubmitReport ? 'pointer' : 'not-allowed',
          pointerEvents: canSubmitReport ? 'auto' : 'none'
        }}
        onClick={(e) => {
          if (!fieldsVisible) {
            return;
          }
          if (!allRowsConfirmed) {
            alert(t('pleaseConfirmAllValuesBeforeSubmitting'));
            return;
          }
          if (!reportConsent) {
            alert('Please consent to processing your lab results to generate the report.');
            return;
          }
          if (collectAllBiomarkersData) {
            const allBiomarkers = collectAllBiomarkersData();
            localStorage.setItem('biomarkers_data', JSON.stringify(allBiomarkers));
            console.log('Saving all biomarkers before navigation:', allBiomarkers);
          }
          saveUserBiomarkersToStorage();
          onGenerateAndUploadPdf();
        }}
      >
        {t('submitBloodTestResults')}
      </button>
    </FixedBottomButton>
  );
};

export default ActionFooter;